import React from 'react'
import { useDispatch } from 'react-redux'
import { Action_user_login_passport } from '../../../store/action/action-user'
import history from '../../hooks/history'

export default function DashboardScreen() {



    console.log('entering DashboardScreen:')


    const dispatch = useDispatch()


    // if (window.location.href.includes('/t')) {
        dispatch(Action_user_login_passport())
        history.push('/')
    // }


    return (
        <div>
            <h3>this is the DashboardScreen</h3>
            <h1>Loading ...</h1>
        </div>
    )
}
